import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Guid } from "@/Common/Models/Guid";
import { PreventiveCareNoticeLetterTypeEnum } from "@/Common/Models/PreventiveCare/PreventiveCareNoticeLetterTypeEnum";

class PreventiveRecallListDto {
    public Id: string;
    public EmployeeContactFacetId: Guid;
    public PatientContactFacetId: Guid;
    public PreventiveCareCriteriaId: Guid;
    public PatientContactId: Guid;
    public PatientFirstName: string;
    public PatientLastName: string;
    public PatientPreferredName: string;
    public HealthCareNumber: string;
    public DateOfBirth: Date;
    public GenderLookupId: Guid;
    public PhoneNumber: PhoneNumber;
    public Address: Address;
    public LetterType: PreventiveCareNoticeLetterTypeEnum;
    public LastCommunicationDate: Date;
    public LastProcedureDate: Date;

    public constructor(init?: Partial<PreventiveRecallListDto>) {
        Object.assign(this, init);
    }
}

export { PreventiveRecallListDto };
